import React, { useState } from 'react';
import { Notification, NotificationType } from '../common';
import { NotificationContext } from './Layout';

/**
 * Minimalny wrapper zapewniający NotificationContext dla stron pełnoekranowych
 * (np. /accounting/edit, /accounting/new), które nie używają pełnego Layout.
 */
const NotificationProviderPage: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const [notificationType, setNotificationType] = useState<NotificationType>('info');
  const [notificationLinkUrl, setNotificationLinkUrl] = useState<string | undefined>(undefined);
  const [notificationTitle, setNotificationTitle] = useState<string | undefined>(undefined);

  const showNotification = (message: string, type: NotificationType, linkUrl?: string, title?: string) => {
    const getDefaultTitle = (t: NotificationType): string => {
      switch (t) {
        case 'success': return 'Sukces';
        case 'warning': return 'Ostrzeżenie';
        case 'error': return 'Błąd';
        case 'info': return 'Info';
        default: return 'Info';
      }
    };
    setNotificationMessage(message);
    setNotificationType(type);
    setNotificationLinkUrl(linkUrl);
    setNotificationTitle(title !== undefined ? title : getDefaultTitle(type));
    setNotificationOpen(true);
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <Notification
        open={notificationOpen}
        message={notificationMessage}
        type={notificationType}
        onClose={() => setNotificationOpen(false)}
        linkUrl={notificationLinkUrl}
        title={notificationTitle}
      />
    </NotificationContext.Provider>
  );
};

export default NotificationProviderPage;
